// Liste des viandes/snacks disponibles pour les mitraillettes et durums (fallback statique)
// Cette liste est normalement chargée depuis menu.json (champ "viandes") et peut être
// modifiée par l'admin. Ce fichier sert de valeur par défaut si le champ n'est pas présent.
const VIANDES_MITRAILLETTE = [
  { name: 'Fricadelle classique', price: 1.80 },
  { name: 'Fricadelle végétarienne', price: 1.80 },
  { name: 'Fricadelle spéciale', price: 2.10 },
  { name: 'Fricadelle XXL', price: 4.00 },

  { name: 'Hamburger', price: 2.80 },
  { name: 'Burger pur boeuf 55gr', price: 2.00 },
  { name: 'Burger pur boeuf 113gr', price: 3.00 },

  { name: 'Cervelas de porc', price: 3.00 },
  { name: 'Cervelas de cheval', price: 3.50 },
  { name: 'Saucisse kermesse', price: 3.50 },

  { name: 'Merguez', price: 3.00 },

  { name: 'Boulette nature', price: 2.60 },
  { name: "Boulette à l'ail", price: 2.60 },
  { name: 'Boulette rotie / maison', price: 2.60 },

  { name: 'Viandelle classique', price: 2.30 },
  { name: 'Viandelle spicy', price: 2.30 },

  { name: 'Brochette de dinde', price: 3.50 },
  { name: 'Brochette de viandes (porc)', price: 3.90 },
  { name: 'Brochette ardennaise', price: 3.80 },
  { name: 'Brochette provençale', price: 4.50 },
  { name: 'Brochette tzigane', price: 3.40 },

  { name: 'Blanc de poulet', price: 4.30 },
  { name: 'Pilons de poulet', price: 4.60 },

  { name: 'Crunchy chicken', price: 4.60 },
  { name: 'Crispy (dinde panée)', price: 2.30 },
  { name: 'Crispy Royal', price: 5.00 },

  { name: 'Poulycroc', price: 3.00 },
  { name: 'Chikkies (6 batonnets de poulet)', price: 4.00 },
  { name: 'Nuggets (5 pièces)', price: 3.60 },

  { name: 'Ragoezi', price: 3.30 },

  { name: 'Viande pitta (250gr)', price: 6.00 },

  { name: 'Croquette de viande', price: 2.00 },
  { name: 'Croquette de volaille', price: 2.80 },
  { name: 'Croquette de nouilles asiatique', price: 3.00 },

  { name: 'Croquette au fromage', price: 3.30 },
  { name: 'Croquette Comté Parmesan', price: 2.50 },
  { name: 'Mozzarella Sticks (5)', price: 3.00 },
  { name: 'Chili cheese nuggets (5)', price: 3.50 },
  { name: 'Cheesecrack', price: 2.90 },

  { name: 'Oignon rings (6)', price: 2.00 },
]

export default VIANDES_MITRAILLETTE
